module.exports = __webpack_public_path__ + "static/img/end-quiz.89d23a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/end-quiz.png
// module id = HFv9
// module chunks = 0